import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import TopBarProgress from "react-topbar-progress-indicator";
import Loadable from "react-loadable";

const Home = Loadable({
  loader: () => import("./routes/home"),
  loading: TopBarProgress,
});

const Offers = Loadable({
  loader: () => import("./routes/offers"),
  loading: TopBarProgress,
});

const Settings = Loadable({
  loader: () => import("./routes/settings"),
  loading: TopBarProgress,
});

const Chat = Loadable({
  loader: () => import("./routes/chat"),
  loading: TopBarProgress,
});

const Leads = () => (
  <Switch>
    <Route path="/home">
      <Home />
    </Route>
    <Route path="/offers">
      <Offers />
    </Route>

    <Route path="/settings">
      <Settings />
    </Route>
    <Route path="/chat">
      <Chat />
    </Route>
    <Redirect to="/home" />
  </Switch>
);

export default Leads;
